import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    IconButton,
    ListItem,
    ListItemText,
    Menu,
    MenuItem,
    TextField,
    Typography,
} from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'
import clsx from 'clsx'
import { bindMenu, bindTrigger, usePopupState } from 'material-ui-popup-state/hooks'
import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useHistory } from 'react-router-dom'

import { getSpecificAreas, sortByKey } from '../../utils'

const useStyles = makeStyles((theme) => ({
	dialog: {
		'& .MuiDialog-paper': {
			// width: '45%',
			width: '468px'
		},
		position: 'relative'
	},
	formWrapper: {
		display: 'flex',
		flexDirection: 'column',
		marginBottom: 20,
		marginTop: 20
		// overflowY: 'scroll'
	},
	fieldWrapper: {
		'&:nth-child(odd)': {
			marginRight: '25px'
		},
		display: 'flex',
		flexDirection: 'column',
		marginBottom: '20px'
	},
	dialogActions: {
		justifyContent: 'flex-start'
		// position: "fixed",
		// bottom: 0
	},
	chips: {
		display: 'flex',
		flexWrap: 'wrap',
		marginTop: '6px',
		backgroundColor: 'transparent !important'
	},
	chip: {
		marginRight: 2
	},
	tableRow: {
		display: 'flex',
		flexDirection: 'row',
		justifyContent: 'flex-start',
		padding: 5
	},
	close: {
		position: 'absolute',
		top: 10,
		right: 10,
		padding: 10,
		fontFamily: 'Nunito',
		fontWeight: '800',
		fontSize: 16,
		cursor: 'pointer'
	},
	cell: {
		width: '20%',
		display: 'flex',
		flexDirection: 'column',
		justifyContent: 'flex-start',
		alignItems: 'flex-start',
		'& h5': {
			fontFamily: 'Nunito',
			fontWeight: '800',
			fontSize: 12,
			margin: 0,
			marginBottom: 3
		},
		'& span': {
			fontFamily: 'Nunito',
			fontSize: 16
		}
	},
	title: {
		display: 'flex',
		flexDirection: 'row',
		justifyContent: 'flex-start',
		alignItems: 'center',
		width: '100%',
		'& h4': {
			margin: 0,
			fontFamily: 'Nunito',
			fontWeight: '800',
			fontSize: 16,
			lineHeight: '22px'
		},
		'& i': {
			marginRight: 10,
			color: '#777679'
		}
	},
	petRow: {
		display: 'flex',
		flexDirection: 'column',
		justifyContent: 'flex-start',
		alignItems: 'center',
		paddingTop: 15,
		width: '100%',
		'& img': {
			height: 50,
			width: 50,
			borderRadius: 25,
			marginRight: 15
		},
		'& h4': {
			fontFamily: 'Nunito',
			fontWeight: '800',
			fontSize: 16
		}
	},
	area: {
		width: '100%',
		display: 'flex',
		flexDirection: 'column',
		justifyContent: 'flex-start',
		marginBottom: 15
	},
	areaTitle: {
		width: '100%',
		display: 'flex',
		flexDirection: 'row',
		justifyContent: 'flex-start',
		alignItems: 'center',
		padding: 10,
		width: '100%',
		'& i': {
			marginRight: 15,
			color: '#D0CFD2'
		},
		'& .selected': {
			color: '#6B4AD6'
		},
		'& h4': {
			margin: 0
		}
	},
	areaMain: {
		width: '100%',
		display: 'flex',
		flexDirection: 'row',
		justifyContent: 'flex-start',
		flexWrap: 'wrap',
		paddingLeft: '10%'
	},
	kennel: {
		padding: 5,
		marginRight: 15,
		marginBottom: 10,
		display: 'flex',
		flexDirection: 'row',
		alignItems: 'flex-start',
		'& i': {
			marginRight: 15,
			color: '#D0CFD2',
			cursor: 'pointer'
		},
		'& .selected': {
			color: '#6B4AD6'
		}
	},
	kennelName: {
		'& h5': {
			margin: 0
		}
	},
	selectedKennels: {
		width: '100%',
		display: 'flex',
		flexDirection: 'row',
		justifyContent: 'flex-start',
		alignItems: 'center',
		height: 50,
		'& i': {
			color: '#6B4AD6',
			fontSize: 18,
			marginRight: 15,
			cursor: 'pointer'
		},
		'& h4': {
			margin: 0,
			fontSize: 16,
			fontFamily: 'Nunito',
			color: '#1A1A35',
			fontWeight: '600'
		}
	}
}))

const PlayAreaDialog = (props) => {
	const classes = useStyles()
	const history = useHistory()
	const visit = useSelector((state) => state.specific.visits.selected)

	const {
		save,
		isShown,
		setIsShown,
		saveAddOn,
		addOn,
		pet,
		visits,
		saveStaff,
		setStaff,
		facility,
		assignKennels,
		selectedPlaygroup,
		saveArea
	} = props

	const [selectedArea, setArea] = useState(null)
	const { indoor, outdoor, kennelRooms } = getSpecificAreas(facility)
	const filteredAreas = [...indoor, ...outdoor].sort(sortByKey((a) => a.name))

	useEffect(() => {
		if (selectedPlaygroup) {
			let area = facility.areas.find((a) => a._id === selectedPlaygroup.area_id)
			setArea(area)
		}
	}, [facility, selectedPlaygroup])

	const resetArea = () => {
		let area = facility.areas.find((a) => a._id === selectedPlaygroup.area_id)
		setArea(area ? area : null)
	}

	return !selectedPlaygroup ? null : (
		<Dialog
			open={isShown}
			aria-labelledby="form-dialog-title"
			className={classes.dialog}
			onClose={() => {
				setIsShown(false)
				resetArea(null)
			}}>
			{/* <DialogTitle style={{ display: 'flex', flexDirection: 'row' }}> */}
			{/* </DialogTitle> */}
			<div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
				<Typography
					style={{
						color: '#1A1A35',
						fontSize: '16px',
						fontWeight: '800',
						lineHeight: '22px',
						marginRight: 17
					}}>
					PLAY AREA ASSIGNMENT
				</Typography>
				<Typography
					style={{
						color: '#5F38BE',
						fontSize: '12px',
						fontWeight: '800',
						lineHeight: '16px',
						textTransform: 'uppercase'
					}}>
					{selectedPlaygroup?.name}
				</Typography>
			</div>
			<DialogContent>
				<IconButton
					className={classes.close}
					onClick={() => {
						setIsShown(false)
						resetArea(null)
					}}>
					X
				</IconButton>

				<div className={classes.formWrapper}>
					<SelectArea
						areas={facility.areas.filter((a) => a.type === 'Indoor Play' || a.type === 'Outdoor Play')}
						selectedArea={selectedArea}
						setArea={setArea}
					/>
				</div>
			</DialogContent>
			<DialogActions className={classes.dialogActions}>
				{/* <Button
					variant="contained"
					onClick={ createAddOn }
					color="secondary"
					>
					Apply
					</Button> */}
				<Button
					variant="contained"
					onClick={() => {
						saveArea(selectedPlaygroup, selectedArea)
						setIsShown(false)
					}}
					color="secondary">
					SAVE
				</Button>
				<Button
					variant="outlined"
					onClick={() => {
						setIsShown(false)
						resetArea(null)
					}}
					color="secondary">
					CANCEL
				</Button>
			</DialogActions>
		</Dialog>
	)
}

const SelectArea = (props) => {
	const classes = useStyles()
	const dispatch = useDispatch()
	let history = useHistory()

	let { areas, selectGroup, selectedArea, setArea } = props

	const popupState = usePopupState({
		variant: 'popover',
		popupId: 'playgroupMenu'
	})

	return (
		<div>
			<ListItem className={clsx(classes.listItem, classes.menu)} {...bindTrigger(popupState)}>
				<ListItemText
					className={classes.selectedFacility}
					primary={selectedArea ? selectedArea.name : 'No Assignment'}
				/>
				<i className={clsx(['fa fa-chevron-down', classes.arrow])} />
			</ListItem>
			<Menu {...bindMenu(popupState)}>
				{areas
					? areas.map((area) => {
							return (
								<MenuItem
									className={classes.listItem}
									onClick={() => {
										popupState.close()
										setArea(area)
									}}
									key={area._id}>
									<ListItemText primary={area.name} />
								</MenuItem>
							)
					  })
					: null}
			</Menu>
		</div>
	)
}

const SelectAreaV1 = (props) => {
	const classes = useStyles()

	let { areas, selectGroup, selectedArea, setArea } = props

	return (
		<div>
			{/* <ListItem className={clsx(classes.listItem, classes.menu)} {...bindTrigger(popupState)}>
				<ListItemText
					className={classes.selectedFacility}
					primary={selectedArea ? selectedArea.name : 'SELECT A PLAY AREA'}
				/>
				<i className={clsx(['fa fa-chevron-down', classes.arrow])} />
			</ListItem>
			<Menu {...bindMenu(popupState)}>
				{areas
					? areas.map((area) => {
							return (
								<MenuItem
									className={classes.listItem}
									onClick={() => {
										popupState.close()
										setArea(area)
									}}
									key={area._id}>
									<ListItemText primary={area.name} />
								</MenuItem>
							)
					  })
					: null}
			</Menu> */}
			<Typography
				style={{
					color: '#1A1A35',
					fontSize: '12px',
					fontWeight: '800',
					lineHeight: '16px',
					textTransform: 'uppercase',
					marginBottom: '8px'
				}}>
				SELECT a play area
			</Typography>
			<TextField
				select
				label="Play Area"
				className={classes.select}
				value={selectedArea?._id}
				onChange={(e) => {
					// popupState.close()
					const found = areas.find((a) => a._id === e.target.value)
					setArea(found)
				}}
				variant="filled">
				{areas?.map(({ _id, name }, i) => (
					<MenuItem key={'playAreaOpts-' + i} value={_id}>
						{name}
					</MenuItem>
				))}
			</TextField>
		</div>
	)
}

export default PlayAreaDialog
